import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/customer/credit/cards', config);
}

const get = async (id) => {
    return FinanceApi.get('/customer/credit/cards/' + id);
}

const store = async (data) => {
    return FinanceApi.post('/customer/credit/cards', data);
}

const del = async (id) => {
    return FinanceApi.delete('/customer/credit/cards/' + id);
}

export default {
    store,
    get,
    getAll,
    del,
}
